module.exports = __webpack_public_path__ + "static/media/icPlayerActiveNew.a8142e82.svg";